/**
 * NegativeKeywordsPanel Component
 * Wrapper for PerformanceMaxNegativeKeywords that fits within the EntityCard context
 *
 * Note: Negative keywords for PMax are at the campaign level, not asset group level.
 * This panel displays the same content regardless of which asset group is expanded.
 */

import React from 'react';
import { PerformanceMaxNegativeKeywords } from '@/components/features/PerformanceMaxNegativeKeywords';
import type { Campaign } from '@/types/campaign';

interface NegativeKeywordsPanelProps {
  campaign: Campaign;
}

export function NegativeKeywordsPanel({ campaign }: NegativeKeywordsPanelProps) {
  // When embedded inside EntityCard, we use the component's "embedded" variant
  // to render without its outer card wrapper and padding.
  return (
    <div className="negative-keywords-panel">
      <PerformanceMaxNegativeKeywords campaign={campaign} variant="embedded" />
    </div>
  );
}

export default NegativeKeywordsPanel;
